import React from "react";

const NoDataMessage = ({ message }) => {
  return (
    <div>
      <p style={{ textAlign: "center", marginTop: "10px" }}>{message}</p>
    </div>
  );
};

export default NoDataMessage;
